import { render } from "./Signup.vue?vue&type=template&id=6a6fd80a&scoped=true&ts=true"
import script from "./Signup.vue?vue&type=script&lang=ts"
export * from "./Signup.vue?vue&type=script&lang=ts"

import "./Signup.vue?vue&type=style&index=0&id=6a6fd80a&scoped=true&lang=css"
import "./Signup.vue?vue&type=style&index=1&id=6a6fd80a&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6fd80a"]])

export default __exports__